var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueRecaptcha',{ref:"recaptcha",attrs:{"sitekey":this.sitekey,"loadRecaptchaScript":true,"size":"invisible"},on:{"verify":_vm.validate,"expired":_vm.onCaptchaExpired}})
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Scripts/app/PasswordReset/Recaptcha.vue